import { Component, OnInit, ViewChild } from '@angular/core';
import { PropiedadesRuralesService } from '../_services';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { OwlCarousel } from 'ngx-owl-carousel';

declare let $: any;
@Component({
  selector: 'app-propiedades-rurales-detalle',
  templateUrl: './propiedades-rurales-detalle.component.html',
  styleUrls: ['./propiedades-rurales-detalle.component.css']
})

export class PropiedadesRuralesDetalleComponent implements OnInit {
  propiedades: any;
  loading = false;
  public id: string;
  @ViewChild('owlElement') owlElement: OwlCarousel;
  constructor(private propiedadesRuralesService: PropiedadesRuralesService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.getPropiedades();
  }
  public getPropiedades() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.propiedadesRuralesService.getPropiedadRural(this.id).subscribe((data: object) => {
      this.propiedades = data;
      this.loading = true;
      if (this.propiedades.imagenes.length > 0) {
        this.propiedades.imagenes.map(i => {
          i.url = environment.baseUrl + '/..' + i.url;
        });
        if (typeof this.owlElement !== 'undefined') {
          this.owlElement.to([0]);
        }
      } else {
      }
    });
  }
}
